const TypeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='21' fill='none' viewBox='0 0 20 21'>
      <path
        fill='#84818A'
        d='M1.043 2.584c0-.345.28-.625.625-.625h16.667c.345 0 .625.28.625.625v13.333c0 .345-.28.625-.625.625H1.668a.625.625 0 01-.625-.625V2.584z'
      ></path>
      <path fill='#84818A' fillRule='evenodd' d='M13.335 19.042H6.668v-1.25h6.667v1.25z' clipRule='evenodd'></path>
    </svg>
  );
};

export default TypeIcon;
